import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterServices'
})
export class FilterServicesPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
